import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import { uploadBytesResumable, getDownloadURL } from "firebase/storage";
import imageCompression from "browser-image-compression";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export const uploadImage = async (image) => {
  try {
    const maxSizeMB = 0.4; // 400 KB

    const options = {
      maxSizeMB: maxSizeMB,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };

    let compressedFile;

    // Compress the image
    if (image.size > 400 * 1024) {
      compressedFile = await imageCompression(image, options);
    } else {
      compressedFile = image;
    }

    const timestamp = Date.now();
    const imageName = `${timestamp}_${image.name}`;
    const storageRef = firebase.storage().ref().child("profile_image");
    const imageRef = storageRef.child(imageName);
    await imageRef.put(compressedFile);
    const imageUrl = await imageRef.getDownloadURL();
    return imageUrl;
  } catch (error) {
    console.error("Error uploading image:", error);
    return "";
  }
};

// export const uploadImages = async (images, setDiscipline) => {
//   try {
//     const imageUrls = [];

//     const compressImagesurl =  await compressImages(images);

//     for (const image of compressImagesurl) {
//       const timestamp = Date.now();
//       const imageName = `${timestamp}_${image.name}`;
//       const storageRef = firebase
//         .storage()
//         .ref()
//         .child(`project_image/${imageName}`);

//       const uploadTask = storageRef.put(image);

//       const imageUrl = await new Promise((resolve, reject) => {
//         uploadTask.on(
//           "state_changed",
//           null,
//           (error) => reject(error),
//           async () => {
//             const downloadURL = await uploadTask.snapshot.ref.getDownloadURL();
//             resolve(downloadURL);
//           }
//         );
//       });

//       imageUrls.push(imageUrl);
//     }

//     setDiscipline((prev) => [
//       {
//         ...prev[0],
//         images: [...prev[0].images, ...imageUrls],
//       },
//     ]);
//     return imageUrls;
//   } catch (error) {
//     console.error("Error uploading images:", error);
//     return [];
//   }
// };



// const compressImages = async (imageArray) => {

//   const maxSizeMB = 0.4; // 400 KB

//   const options = {
//     maxSizeMB,
//     maxWidthOrHeight: 1920,
//     useWebWorker: true,
//   };

//   const compressedImages = await Promise.all(
//     imageArray.map(async (image) => {
//       if (image.size > 400 * 1024) {
//         const compressed = await imageCompression(image, options);
//         return compressed;
//       } else {
//         return image;
//       }
//     })
//   );

//   return compressedImages;
// };


export const uploadImages = async (images) => {
  try {
    // Compress images first
    const compressedImages = await compressImages(images);
    
    // Upload all images in parallel
    const uploadPromises = compressedImages.map(async (image) => {
      const timestamp = Date.now();
      const imageName = `${timestamp}_${image.name}`;
      const storageRef = firebase.storage().ref(`project_image/${imageName}`);
      
      await storageRef.put(image); // Upload

      return storageRef.getDownloadURL(); // Get the download URL
    });

    const imageUrls = await Promise.all(uploadPromises);

    return imageUrls;

  } catch (error) {
    console.error("Error uploading images:", error);
    return [];
  }
};

const compressImages = async (imageArray) => {
  const options = {
    maxSizeMB: 0.4,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
  };

  return Promise.all(
    imageArray.map((image) =>
      image.size > 400 * 1024
        ? imageCompression(image, options)
        : image
    )
  );
};
